import { useCallback, useEffect, useState } from "react";

const useYearFilter = () => {
    const [data1, setData1] = useState();

    const getYear = useCallback(async () => {
        let currentYear = new Date().getFullYear() + 1;
        const Years = [{ name: "เลือกทั้งหมด", value: ""}];

        for (let index = 0; index < 5; index++) {
            let element = { name: currentYear + 543 - index, value: currentYear + 543 - index };
            Years.push(element);
        }

        setData1(Years);
    }, [setData1]);

    useEffect(() => {
        getYear();
    }, [getYear]);

    return [data1];
};

export default useYearFilter;
